import { render } from "./TransferenciaEstoqueIndex.vue?vue&type=template&id=11e9027a&scoped=true&ts=true"
import script from "./TransferenciaEstoqueIndex.vue?vue&type=script&lang=ts"
export * from "./TransferenciaEstoqueIndex.vue?vue&type=script&lang=ts"

import "./TransferenciaEstoqueIndex.vue?vue&type=style&index=0&id=11e9027a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e9027a"]])

export default __exports__